<div class="organisation-delete-panel" data-testid="organisation-delete-panel">
    @if (isLinked) {
        <div class="alert alert-warning" role="status" id="organisation-delete-warning" data-testid="organisation-delete-warning">
            <p class="mb-1">This organisation cannot be deleted while it is linked to contracts or services.</p>
            @if (linkedContracts.length > 0) {
                <p class="mb-0 fw-semibold">Contracts</p>
                <ul class="list-bulleted mb-1">
                    @for (contract of linkedContracts; track contract.id) {
                        <li>{{ contract.title }}</li>
                    }
                </ul>
            }
            @if (linkedServices.length > 0) {
                <p class="mb-0 fw-semibold">Services</p>
                <ul class="list-bulleted mb-0">
                    @for (service of linkedServices; track service.id) {
                        <li>{{ service.name }}</li>
                    }
                </ul>
            }
        </div>
    }
    <button type="button" class="btn btn-outline-danger organisation-delete-btn"
            data-testid="organisation-delete"
            [disabled]="isLinked"
            [attr.aria-describedby]="isLinked ? 'organisation-delete-warning' : null"
            aria-haspopup="dialog"
            (click)="openDelete()">
        <i class="bi bi-trash me-2" aria-hidden="true"></i>Delete organisation
    </button>
</div>
